/* eslint-disable @typescript-eslint/no-unused-vars */
import moment from 'moment'

/**
 * Formats a createdAt timestamp into a human-friendly relative string using moment.js
 * - < 1 min       -> "Just now"
 * - < 60 min      -> "5m ago"
 * - < 24 hrs      -> "3h ago"
 * - yesterday     -> "Yesterday, 4:30 PM"
 * - < 7 days      -> "Tuesday, 4:30 PM"
 * - same year     -> "12 Mar"
 * - older         -> "12 Mar 2024"
 */
export const formatNotificationTime = (createdAt: string | number | Date): string => {
  const date = moment(createdAt)
  const now = moment()

  const diffSec = now.diff(date, 'seconds')
  const diffMin = now.diff(date, 'minutes')
  const diffHour = now.diff(date, 'hours')
  const diffDay = now.diff(date, 'days')

  if (diffSec < 60) return 'Just now'
  if (diffMin < 60) return `${diffMin}m ago`
  if (date.isSame(now, 'day')) return `${diffHour}h ago`

  return date.calendar(null, {
    lastDay: '[Yesterday,] h:mm A',
    lastWeek: 'dddd, h:mm A',
    sameElse: () => (date.isSame(now, 'year') ? 'D MMM' : 'D MMM YYYY'),
  })
}